import api from "@/services/api/api-reservedExams"
import ResultModel, { RESERVED_EXAM } from "./models/resultModel"

export default class ResultsService {
  async list(query) {
    try {
      let res = await api.list(query)
      if(!res.results) throw new Error('Something wrong and results not loading. Please, reload page or try later.')
      let data = {
        results: res.results.map( item => new ResultModel(item)),
        pagination: {
          count: res.count,
          next: res.next,
          previous: res.previous
        }
      }
      return data
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async loadResults(query) {
    try {
      let res = await api.loadResults(query)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async loadResult(ID) {
    try {
      let res = await api.loadResult(ID)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async saveResults(ID, data) {
    try {
      return await api.setResult(ID, data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async markSeen(ID) {
    try {
      let res = await api.markSeen(ID)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async startMonitoring() {
    try {
      let res = await api.startMonitoring()
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async stopMonitoring() {
    try {
      let res = await api.stopMonitoring()
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async monitoringStatus() {
    try {
      let res = await api.monitorStatus()
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateHasComeToCourse(ID, val) {
    try {
      let res = await api.patch(ID, {
        [RESERVED_EXAM.HAS_COME_TO_COURSE]: val
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async saveNote(ID, data) {
    try {
      let res = await api.patch(ID, {notes: data})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

}